import {
    FaUser,
    FaBed,
} from "react-icons/fa";
import tw from "tailwind-styled-components";
import { MdOutlineChevronRight } from "react-icons/md";


function SummaryCards({ summaryData, setSelectedFilter, selectedId, setSelectedId, handleClearFilter, propId, holdBedCount }) {
    const allCardsData = [
        {
            count: summaryData?.totalBeds || 0,
            label: "Total Beds",
            color: "text-black",
            icon: <FaBed className="text-amber-400" />,
            filter: "ALL",
        },
        {
            count: summaryData?.occupiedBeds || 0,
            label: "Occupied Beds",
            color: "text-black",
            icon: <FaUser className="text-blue-400" />,
            filter: "OCCUPIED",
        },
        {
            count: summaryData?.vacantBeds || 0,
            label: "Vacant Beds",
            color: "text-black",
            icon: <FaUser className="text-green-400" />,
            filter: "VACANT",
        },
        {
            count: summaryData?.dueTenantCount || 0,
            label: "Pending Dues",
            color: "text-black",
            icon: <FaBed className="text-sky-400" />,
            filter: "PENDING_DUES",
        },
        {
            count: summaryData?.movingOut || 0,
            label: "Moving Out",
            color: "text-black",
            icon: <FaUser className="text-red-400" />,
            filter: "MOVING_OUT",
        },
        {
            // count: summaryData?.onHoldBeds || 0,
            count: holdBedCount ?? summaryData?.onHoldBeds ?? 0,
            label: "On Hold Beds",
            color: "text-black",
            icon: <FaUser className="text-red-400" />,
            filter: "ON_HOLD",
        },
        {
            count: summaryData?.deadBeds || 0,
            label: "Dormant Beds",
            color: "text-black",
            icon: <FaUser className="text-red-400" />,
            filter: "DORMANT",
        },
    ];

    const currentRoomData = propId === 0
        ? allCardsData.filter(item => item.filter !== "PENDING_DUES")
        : allCardsData;

    return (
        <Wrapper>
            <ScrollCard
                style={{
                    scrollBehavior: "smooth",
                }}
            >
                {currentRoomData.map((item, index) => (
                    <Card
                        selectedId={selectedId}
                        index={index}
                        key={index}
                        // onClick={propId === 0 ? undefined : () => {
                        //     setSelectedId(index);
                        //     setSelectedFilter(item.filter);
                        // }}
                        onClick={
                            propId === 0
                                ? undefined
                                : () => {
                                    if (selectedId === index) {
                                        // Toggle OFF
                                        setSelectedId(null);
                                        handleClearFilter();
                                    } else {
                                        // Select
                                        setSelectedId(index);
                                        setSelectedFilter(item.filter);
                                    }
                                }
                        }
                        $clickable={propId !== 0}
                    >
                        <div className="h-14">
                            <Value color={item.color}>{item.count}</Value>
                            <Label>
                                {item.label}
                                {propId !== 0 && (
                                    <MdOutlineChevronRight className="text-gray-300" size={24} />
                                )}
                            </Label>
                        </div>
                    </Card>
                ))}
            </ScrollCard>
        </Wrapper>
    );
}

const Wrapper = tw.div`w-full`;
const ScrollCard = tw.div`w-full overflow-x-auto flex space-x-4 py-[1.5px]`;
const Card = tw.div`
    min-w-[150px] p-3 rounded-md bg-white shadow-md 
    ${({ $clickable }) => $clickable ? 'cursor-pointer hover:shadow-sm hover:shadow-primary-color' : 'cursor-default'}
    ${({ selectedId, index }) => selectedId === index ? "shadow-sm shadow-primary-color" : ""}
`;
const Label = tw.div`text-gray-500 text-xs break-words flex items-center w-full mt-2 justify-between break-words whitespace-normal w-full`;

const Value = tw.p`
    text-xl font-bold  
    ${({ color }) => color}
`;

export default SummaryCards;